import React from 'react';
import Typography from '@mui/material/Typography';
import { Button, Grid, IconButton, Link } from '@mui/material';
import Icon from 'src/components/color-utils/Icon';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';
import { color } from 'framer-motion';
import FolderCopyIcon from '@mui/icons-material/FolderCopy';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import DialogCalendar from 'src/components/dialog/dialogcalendar';
import { set } from 'lodash';
import { Circle } from '@mui/icons-material';
import { getToken } from 'src/utils/common';

export default function CalendarPage() {
  //   const year = 2023; // Replace with the desired year
  //   const month = 1;
  const currentDate = new Date();
  const [year, setYear] = React.useState(currentDate.getFullYear());
  const currentMonthNumber = currentDate.getMonth() + 1; // Adding 1 to make it 1-based
  const [month, setMonth] = React.useState(currentMonthNumber);
  const daysArray = getDaysArrayByMonth(year, month);
  const [data, setData] = React.useState([]);
  const [calendardialog, setCalendarDialog] = React.useState({
    open: false,
    data: [],
    date: '',
  });
  const [search, setSearch] = React.useState('');

  const fetchInfo = (url) => {
    return fetch(url, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    })
      .then((res) => res.json())
      .then((d) => setData(d.data));
  };
  const handlemonth = (e) => {
    if (month >= 12) {
      setYear(year + 1);
      setMonth(1);
      fetchInfo(window.REACT_APP_API_PURE + 'calendar/list?month=1' + '&year=' + (year + 1));
    } else {
      setMonth(month + 1);
      fetchInfo(window.REACT_APP_API_PURE + 'calendar/list?month=' + (month + 1) + '&year=' + year);
    }
  };
  const handlemonthback = (e) => {
    if (month <= 1) {
      setYear(year - 1);
      setMonth(12);
      fetchInfo(window.REACT_APP_API_PURE + 'calendar/list?month=12' + '&year=' + (year - 1));
    } else {
      setMonth(month - 1);
      fetchInfo(window.REACT_APP_API_PURE + 'calendar/list?month=' + (month - 1) + '&year=' + year);
    }
  };

  React.useEffect(() => {
    fetchInfo(window.REACT_APP_API_PURE + 'calendar/list');
  }, []);

  function Refresh() {
    fetchInfo(window.REACT_APP_API_PURE + 'calendar/list');
  }

  function getDaysArrayByMonth(year, month) {
    const daysArray = [];
    const startDate = new Date(year, month - 1, 1); // First day of the month
    const endDate = new Date(year, month, 0); // Last day of the month

    let currentDate = startDate;

    while (currentDate <= endDate) {
      daysArray.push(new Date(currentDate));
      currentDate.setDate(currentDate.getDate() + 1);
    }

    return daysArray;
  }
  function getDayName(dateString) {
    const days = [t('day.1'), t('day.2'), t('day.3'), t('day.4'), t('day.5'), t('day.6'), t('day.7')];
    const date = new Date(dateString);
    const dayName = days[date.getDay()];
    return dayName;
  }
  function getDayNumber(dateString) {
    const date = new Date(dateString);
    const dayNumber = date.getDate();
    return dayNumber;
  }
  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }

  function DayCard({ date, index }) {
    const isCurrentDate = date.toDateString() === currentDate.toDateString();

    const filteredData = data?.filter((d) => {
      return formatDate(d.time_start) === formatDate(date.toLocaleDateString());
    });

    return (
      <div
        onClick={() => {
          if (filteredData.length > 0) {
            setCalendarDialog({
              open: true,
              data: filteredData,
              date: isCurrentDate,
            });
          }
        }}
        style={{ height: 90, padding: '10px', width: '50%', textAlignLast: 'center' }}
      >
        {index == 0 ? (
          <div>
            <Typography variant="caption" style={{ color: '#888888' }}>
              {getDayName(date.toLocaleDateString())}
            </Typography>
          </div>
        ) : (
          ''
        )}
        <div
          style={{
            backgroundColor: isCurrentDate ? '#1EB3D9' : 'transparent',
            color: isCurrentDate
              ? 'white'
              : index == 28 && getDayNumber(date.toLocaleDateString()) < 28
              ? '#B0B0B0'
              : 'black',
            display: isCurrentDate ? 'inline-flex' : '',
            padding: isCurrentDate ? 2 : '',
            borderRadius: 5,
          }}
        >
          <Typography variant="caption">{getDayNumber(date.toLocaleDateString())}</Typography>
        </div>
        {filteredData?.length == 0 || filteredData == undefined ? (
          ''
        ) : (
          <Grid container direction={'row'} justifyContent={'center'}>
            {' '}
            {filteredData
              ?.filter((d) => {
                if (search == '') {
                  return d;
                } else {
                  return d.title.toLowerCase().includes(search.toLowerCase());
                }
              })
              .map((d, index) => {
                if (index < 3) {
                  return (
                    <Grid item>
                      <Circle
                        fontSize="1px"
                        style={{
                          height: 5,
                          paddingRight: 2,
                          width: 5,
                          color: d.schedule == 'Daily' ? '#1EB3D9' : d.schedule == 'Weekly' ? '#8667EB' : '#F9A207',
                        }}
                      />
                    </Grid>
                  );
                } else {
                  return null;
                }
              })}
            <Grid />
            {filteredData.length <= 3 ? (
              ''
            ) : (
              <Link
                onClick={() => {
                  if (filteredData.length > 0) {
                    setCalendarDialog({
                      open: true,
                      data: filteredData,
                      date: isCurrentDate,
                    });
                  }
                }}
              >
                {/* <Typography variant="caption">{filteredData.length - 3} more</Typography> */}
              </Link>
            )}{' '}
          </Grid>
        )}
      </div>
    );
  }
 const { t } = useTranslation();

 function handleClickLang(lang) {
   i18next.changeLanguage(lang);
 }
  function DayList({ daysArray }) {
    const rows = [];

    const getDaysArrayByMonth = (year, month) => {
      const daysInMonth = new Date(year, month, 0).getDate();
      return Array.from({ length: daysInMonth }, (_, i) => new Date(year, month - 1, i + 1));
    };

    // Calculate the number of days needed to pad to reach a total of 35 days
    const remainingDays = 35 - daysArray.length;

    // Get the next month's days to fill the remaining days
    const nextMonth = getDaysArrayByMonth(year, month + 1); // You can replace 6 with the next month

    const paddedDaysArray = [...daysArray, ...nextMonth.slice(0, remainingDays)];

    for (let i = 0; i < paddedDaysArray.length; i += 7) {
      const rowDays = paddedDaysArray.slice(i, i + 7);
      rows.push(
        <div style={{ display: 'flex' }} key={i}>
          {rowDays.map((day, index) => {
            return <DayCard key={index} date={day} index={i} />;
          })}
        </div>
      );
    }

    return <div>{rows}</div>;
  }

  function DayCardRight({ date, index }) {
    const isCurrentDate = date.toDateString() === currentDate.toDateString();

    const filteredData = data?.filter((d) => {
      return formatDate(d.time_start) === formatDate(date.toLocaleDateString());
    });

    return (
      <Grid item xs={12} style={{ padding: 10, borderTop: '1px solid ' }}>
        <div
          onClick={() => {
            if (filteredData.length > 0) {
              setCalendarDialog({
                open: true,
                data: filteredData,
                date: isCurrentDate,
              });
            }
          }}
          // style={{ textAlignLast: 'center' }}
        >
          <Grid container direction={'row'} xs={12} spacing={2}>
            <Grid item style={{ alignSelf: 'center' }}>
              <div
                style={{
                  backgroundColor: isCurrentDate ? '#1EB3D9' : 'transparent',
                  color: isCurrentDate
                    ? 'white'
                    : index == 28 && getDayNumber(date.toLocaleDateString()) < 28
                    ? '#B0B0B0'
                    : 'black',
                  display: isCurrentDate ? 'inline-flex' : '',
                  padding: isCurrentDate ? 2 : '',
                  borderRadius: 5,
                }}
              >
                <Typography variant="caption">{getDayNumber(date.toLocaleDateString())}</Typography>
              </div>
            </Grid>
            <Grid item container direction={'row'} xs>
              {' '}
              {filteredData
                ?.filter((d) => {
                  if (search == '') {
                    return d;
                  } else {
                    return d.title.toLowerCase().includes(search.toLowerCase());
                  }
                })
                .map((d, index) => {
                  if (index < 3) {
                    return (
                      // FolderCopyIcon
                      <div
                        style={{
                          color: 'white',
                          marginRight: 5,
                          padding: 5,
                          borderRadius: 5,
                          backgroundColor:
                            d.schedule == 'Daily' ? '#1EB3D9' : d.schedule == 'Weekly' ? '#8667EB' : '#F9A207',
                          cursor: 'pointer',
                        }}
                      >
                        <Grid item container direction={'row'}>
                          <Grid item>
                            <FolderCopyIcon style={{ color: 'white', height: 12, width: 12 }} />
                          </Grid>
                          <Grid item>
                            <Typography variant="caption">
                              {d.title.length > 10 ? `${d.title.slice(0, 10)}...` : d.title}
                            </Typography>
                          </Grid>
                        </Grid>
                      </div>
                    );
                  } else {
                    return null;
                  }
                })}
              {filteredData?.length <= 3 || filteredData?.length == undefined ? (
                ''
              ) : (
                <Link
                  onClick={() => {
                    // setCalendarDialog({
                    //   open: true,
                    //   data: filteredData,
                    //   date: isCurrentDate,
                    // });
                  }}
                >
                  <Typography variant="caption" style={{ cursor: 'pointer' }}>
                    {filteredData?.length - 3} more
                  </Typography>
                </Link>
              )}{' '}
            </Grid>
          </Grid>
        </div>{' '}
      </Grid>
    );
  }

  const NewArray = ({ daysArray }) => {
    const rows = [];

    const getDaysArrayByMonth = (year, month) => {
      const daysInMonth = new Date(year, month, 0).getDate();
      return Array.from({ length: daysInMonth }, (_, i) => new Date(year, month - 1, i + 1));
    };

    // Calculate the number of days needed to pad to reach a total of 35 days
    const remainingDays = 35 - daysArray.length;

    // Get the next month's days to fill the remaining days
    const nextMonth = getDaysArrayByMonth(year, month + 1); // You can replace 6 with the next month

    const paddedDaysArray = [...daysArray, ...nextMonth.slice(0, remainingDays)];

    for (let i = 0; i < paddedDaysArray.length; i += 1) {
      const rowDays = paddedDaysArray.slice(i, i + 1);
      rows.push(
        rowDays.map((day, index) => {
          return <DayCardRight key={index} date={day} index={i} />;
        })
      );
    }

    return rows;
  };
  function getMonthName(monthNumber) {
    const months = [
      t('month.1'),
      t('month.2'),
      t('month.3'),
      t('month.4'),
      t('month.5'),
      t('month.6'),
      t('month.7'),
      t('month.8'),
      t('month.9'),
      t('month.10'),
      t('month.11'),
      t('month.12')
    ];

    // Ensure the monthNumber is in the valid range (1 to 12)
    if (monthNumber >= 1 && monthNumber <= 12) {
      return months[monthNumber - 1];
    } else {
      // Handle invalid month number
      return 'Invalid Month';
    }
  }
  function handleClose() {
    setCalendarDialog((current) => ({
      ...current,
      open: false,
    }));
  }

  return (
    <Grid container direction={'row'}>
      <Grid item xs={7} style={{ borderRight: '1px solid #E7E7E7' }}>
        <div>
          {
            <DialogCalendar
              open={calendardialog.open}
              data={calendardialog.data}
              handleClose={handleClose}
              date={calendardialog.date}
              refresh={Refresh}
            />
          }
          <Grid container direction="row" style={{ borderBottom: '1px solid #E7E7E7' }}>
            <Grid item container direction={'row'} xs={12} justifyContent={'space-between'}>
              <Grid item>
                {' '}
                <Typography variant="h5" sx={{ p: 2, paddingLeft: 5 }}>
                  {t('Calendar.1')}
                </Typography>
              </Grid>
              <Grid item alignSelf={'center'}>
                <Typography variant="h5" sx={{ p: 2, paddingRight: 5 }}>
                  {year}
                </Typography>
              </Grid>
            </Grid>
            <Grid item xs={12} container direction={'row'} justifyContent={'center'} spacing={6}>
              <Grid item>
                {' '}
                <IconButton style={{ color: '#12A2CE' }} onClick={handlemonthback}>
                  <ArrowBackIosIcon />
                </IconButton>
              </Grid>
              <Grid item alignSelf={'center'}>
                {getMonthName(month)}
              </Grid>
              <Grid item>
                <IconButton style={{ color: '#12A2CE' }} onClick={handlemonth}>
                  <ArrowForwardIosIcon />
                </IconButton>
              </Grid>
            </Grid>
          </Grid>

          {/* {daysArray.map((day) => { */}
          <DayList daysArray={daysArray} />
          {/* <div style={{ height: 50 }}></div> */}
          {/* })} */}
        </div>
      </Grid>
      <Grid item container direction={'row'} xs={5} style={{ padding: 20, maxHeight: 550, overflow: 'auto' }}>
        <Grid xs={12} item>
          <Typography>{t('VerifSchedule.1')}</Typography>
        </Grid>

        <Grid xs={12} item container direction={'row'} spacing={2} style={{ marginTop: 20 }}>
          {NewArray({ daysArray: daysArray })}
        </Grid>
      </Grid>
    </Grid>
  );
}
